// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"32eceebac5047dcd","6831":"d18d7ccddfef3fae","8503":"150daee89e25e51a","9683":"e48a94642ccb2237"}[chunkId] + ".js";
};